<template>
  <v-flex
    v-if="getSheetDescriptionQuestions.hasOwnProperty('filling_manual')"
    id="instruction"
    class="question"
  >
    <p class="required-block_left mt-3 mb-2">
      {{ $t('sheet.fields_required') }}
    </p>
    <h2 class="header">
      {{ getSheetDescriptionQuestions.filling_manual.label }}
    </h2>
    <div class="content">
      <p
        v-for="(text, index) in getSheetDescriptionQuestions.filling_manual.text"
        :key="index"
        v-html="text"
      />
      <infoAlert
        v-if="getSheetDescriptionQuestions.filling_manual.hasOwnProperty('important_info')"
        :text="getSheetDescriptionQuestions.filling_manual.important_info.text[1]"
        :warn-text="getSheetDescriptionQuestions.filling_manual.important_info.text[0]"
      />
    </div>
    <turnOffModal
      :visible="turnOffVisible"
      :family-id="familyId"
      :reasons-id="2"
      @close="turnOffVisible = false"
      @reload="goToFamilyCard"
    />
    <descriptionExamplesDialog v-model="examplesDialog" />
  </v-flex>
</template>

<script>
import infoAlert from '@/components/widgets/InfoAlert';
import turnOffModal from '@/components/familyCard/TurnOffModal';
import descriptionExamplesDialog from '@/components/description/descripionExamplesDialog';
import listenersManager from '@/mixins/sheet/listenersManager';

import links from '@/constants/links';
import { mapGetters } from 'vuex';

export default {
    name: 'DescriptionInstruction',
    components: { turnOffModal, infoAlert, descriptionExamplesDialog },
    mixins: [listenersManager],
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            links,
            turnOffVisible: false,
            examplesDialog: false
        };
    },
    computed: {
        ...mapGetters('sheet', ['getSheetDescriptionQuestions']),
        familyId () {
            return this.$route.params.familyId;
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        },
        descriptionElearning () {
            return document.querySelector('[ref="descriptionElearning"]');
        },
        familyDescriptionExamples () {
            return document.querySelector('[ref="familyDescriptionExamples"]');
        },
        descriptionDisableFamilyEdition () {
            return document.querySelector('[ref="descriptionDisableFamilyEdition"]');
        }
    },
    mounted () {
        if (this.descriptionElearning) {
            this.descriptionElearning.setAttribute('href', this.links.FAMILY_DESCRIPTION_GUIDE);
            this.descriptionElearning.setAttribute('target', '_blank');
        }

        if (!this.isCurrentEdition) {
            this.descriptionElearning && this.descriptionElearning.setAttribute('disabled', 'disabled');
            this.familyDescriptionExamples &&
        this.familyDescriptionExamples.setAttribute('disabled', 'disabled');
        }

        (!this.isCurrentEdition || this.readOnly) &&
      this.descriptionDisableFamilyEdition &&
      this.descriptionDisableFamilyEdition.setAttribute('disabled', 'disabled');

        this.familyDescriptionExamples &&
      this.setListener(this.familyDescriptionExamples, this.openExamples);
        this.descriptionDisableFamilyEdition &&
      this.setListener(this.descriptionDisableFamilyEdition, this.turnOff);
    },
    beforeDestroy () {
        this.familyDescriptionExamples &&
      this.removeListener(this.familyDescriptionExamples, 'click', this.openExamples);
        this.descriptionDisableFamilyEdition &&
      this.removeListener(this.descriptionDisableFamilyEdition, 'click', this.turnOff);
    },
    methods: {
        turnOff (e) {
            e.preventDefault();
            if (this.readOnly === true) {
                return;
            }
            this.turnOffVisible = true;
        },
        goToFamilyCard () {
            this.$router.push({ name: 'family-card', params: { id: this.familyId } });
        },
        openExamples (e) {
            e.preventDefault();
            this.examplesDialog = true;
        }
    }
};
</script>

<style scoped></style>
